var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ELSInlineLoader } from '@els/els-ui-common-react';
import classnames from 'classnames';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import { Component, createElement, forwardRef, lazy, Suspense } from 'react';
import { ELSCheckBox, DropDown, ELSIcon, ELSSlideSwitch, ELSTextBox } from 'components/common';
import { Collapse, CollapsePanel } from 'components/common/collapse';
import { PRESS_KEYS, TABLE_FILTER_DATE_EVENT, TABLE_FILTER_DATE_FORMAT, TABLE_FILTER_DATE_PICKER_FORMAT, TABLE_FILTER_MONTH_YEAR_DISPLAY_FORMAT, TABLE_FILTER_MONTH_YEAR_FORMAT } from 'constants/app.constant';
import { MULTIPLE_SELECTED_DISPLAY } from 'constants/filter.constant';
import { TableFilterRowType } from 'models';
import 'react-datepicker/dist/react-datepicker.css';
import { buildEmptyRowsState, buildEmptyRowState } from 'services/filter.service';
import SearchBar from '../search-bar/SearchBar';
import { CheckboxMenu } from '../select-menu';
var DatePicker = lazy(function () { return import('../date-picker/DatePicker'); });
var ELSDatePicker = lazy(function () { return import('@els/els-react--date-picker').then(function (module) { return ({ default: module.DatePicker }); }); });
var PerformanceReportModal = lazy(function () { return import('components/common/performance-report-modal/PerformanceReportModal'); });
var TableFilterTag = lazy(function () { return import('./table-filter-tag/TableFilterTag'); });
export var CustomInputDatePicker = function (props, ref) {
    return (<div id={props.id ? "field-wrap-".concat(props.id) : undefined} className="c-els-field">
      <div className="c-els-field__label">
        <span className="c-els-field__wrap c-els-field__wrap--icon-right">
          <ELSIcon name="calendar" direction="right" aria-hidden="true"/>
          <input ref={ref} aria-label="Select date" {...props} tabIndex={0} className="c-els-field__input c-table-filter-modal__month-year-row-custom-input"/>
        </span>
      </div>
    </div>);
};
var TableFilter = /** @class */ (function (_super) {
    __extends(TableFilter, _super);
    function TableFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSetIsPressEsc = function (val) {
            _this.setState({ isPressEsc: val });
        };
        _this.updateState = function (row, value, field) {
            var _a, _b;
            var filterData = _this.state.editingRowsState[row.field] || buildEmptyRowState(row.type);
            switch (row.type) {
                case TableFilterRowType.DECIMAL_RANGE: {
                    filterData[field] = parseFloat(value.toString());
                    filterData.hasData = !!(filterData.from || filterData.to);
                    break;
                }
                case TableFilterRowType.RANGE: {
                    filterData[field] = parseInt(value.toString(), 10);
                    filterData.hasData = !!(filterData.from || filterData.to);
                    break;
                }
                case TableFilterRowType.MULTI_SELECT: {
                    var checkedKeys = filterData.checkedKeys;
                    if (checkedKeys.includes(value.toString())) {
                        checkedKeys = checkedKeys.filter(function (key) { return key !== value; });
                    }
                    else {
                        checkedKeys.push(value.toString());
                    }
                    filterData.checkedKeys = checkedKeys;
                    filterData.hasData = !!checkedKeys.length;
                    break;
                }
                case TableFilterRowType.SLIDE_SWITCH: {
                    filterData.isChecked = !!value;
                    filterData.hasData = true;
                    break;
                }
                case TableFilterRowType.DATE_RANGE:
                case TableFilterRowType.MONTH_RANGE: {
                    filterData[field] = value;
                    filterData.hasData = !!(filterData.from || filterData.to);
                    break;
                }
                case TableFilterRowType.DROPDOWN: {
                    filterData.selectedOptionValue = value.toString();
                    filterData.hasData = !!value;
                    break;
                }
                case TableFilterRowType.CHECKBOX_MENU: {
                    var checkedKeys = value;
                    filterData.checkedKeys = checkedKeys;
                    if (row.options.length === checkedKeys.length) {
                        filterData.hasData = false;
                    }
                    else {
                        filterData.hasData = !!checkedKeys.length;
                    }
                    break;
                }
                default: {
                    break;
                }
            }
            (_b = (_a = _this.props).onFilterFieldChange) === null || _b === void 0 ? void 0 : _b.call(_a);
            _this.setState(function (prevState) {
                var _a;
                return ({
                    editingRowsState: __assign(__assign({}, prevState.editingRowsState), (_a = {}, _a[row.field] = filterData, _a))
                });
            });
        };
        _this.renderMonthYearRangeRow = function (rowConfig) {
            var rowState = _this.state.editingRowsState[rowConfig.field];
            var labelId = "".concat(rowConfig.key, "-label");
            return (<div key={rowConfig.key} role="group" aria-labelledby={labelId} className="c-table-filter-modal__row c-table-filter-modal__date-range-row">
        <span id={labelId} className="u-els-font-size-body-large c-table-filter-modal__range-row-label">
          {rowConfig.label}
        </span>
        <Suspense fallback={<ELSInlineLoader />}>
          <div className="c-table-filter-modal__range-row-input-container">
            <DatePicker value={rowState === null || rowState === void 0 ? void 0 : rowState.from} handleCallback={function (date) {
                    _this.dateRangeChangeHandler(TABLE_FILTER_DATE_EVENT.startDateChange, date, rowConfig);
                }} dateFormat={TABLE_FILTER_MONTH_YEAR_FORMAT} placeholderText={TABLE_FILTER_MONTH_YEAR_DISPLAY_FORMAT} customInput={createElement(forwardRef(CustomInputDatePicker))} showMonthYearPicker handleFocusCallback={_this.handleSetIsPressEsc} inputAriaLabel={"".concat(rowConfig.label, " start date")}/>
            <span aria-hidden="true" className="u-els-margin-1o2 c-table-filter-modal__range-row-to">
              to
            </span>
            <DatePicker value={rowState === null || rowState === void 0 ? void 0 : rowState.to} handleCallback={function (date) {
                    if (date) {
                        var endOfMonth = moment(date).endOf('month').toDate();
                        _this.dateRangeChangeHandler(TABLE_FILTER_DATE_EVENT.endDateChange, endOfMonth, rowConfig);
                    }
                    else {
                        _this.dateRangeChangeHandler(TABLE_FILTER_DATE_EVENT.endDateChange, null, rowConfig);
                    }
                }} dateFormat={TABLE_FILTER_MONTH_YEAR_FORMAT} placeholderText={TABLE_FILTER_MONTH_YEAR_DISPLAY_FORMAT} customInput={createElement(forwardRef(CustomInputDatePicker))} minDate={(rowState === null || rowState === void 0 ? void 0 : rowState.from) ? moment(rowState.from).toDate() : null} showMonthYearPicker handleFocusCallback={_this.handleSetIsPressEsc} inputAriaLabel={"".concat(rowConfig.label, " end date")}/>
          </div>
        </Suspense>
      </div>);
        };
        _this.renderRangeRow = function (rowConfig) {
            var rowState = _this.state.editingRowsState[rowConfig.field];
            var labelId = "".concat(rowConfig.key, "-label");
            var containerClasses = classnames('c-table-filter-modal__row c-table-filter-modal__range-row', {
                'c-table-filter-modal__range-row--percent': rowConfig.isPercent
            });
            return (<div key={rowConfig.key} role="group" aria-labelledby={labelId} className={containerClasses}>
        <div id={labelId} className="u-els-font-size-body-large c-table-filter-modal__range-row-label">
          {rowConfig.label}
        </div>
        <div className="c-table-filter-modal__range-row-input-container">
          <ELSTextBox type="number" cssClasses="c-table-filter-modal__range-row-input" placeholder={(rowConfig === null || rowConfig === void 0 ? void 0 : rowConfig.min) || '0'} value={(rowState === null || rowState === void 0 ? void 0 : rowState.from) || ''} ariaAttrs={{ 'aria-label': "".concat(rowConfig.label, " from") }} changeHandler={function (evt) {
                    _this.updateState(rowConfig, evt.target.value, 'from');
                }}/>
          <span aria-hidden="true" className="c-table-filter-modal__range-row-to">
            to
          </span>
          <ELSTextBox type="number" cssClasses="c-table-filter-modal__range-row-input" placeholder={(rowConfig === null || rowConfig === void 0 ? void 0 : rowConfig.max) || 'max'} value={(rowState === null || rowState === void 0 ? void 0 : rowState.to) || ''} ariaAttrs={{ 'aria-label': "".concat(rowConfig.label, " to") }} changeHandler={function (evt) {
                    _this.updateState(rowConfig, evt.target.value, 'to');
                }}/>
        </div>
      </div>);
        };
        _this.renderMultiSelectRow = function (rowConfig) {
            var rowState = _this.state.editingRowsState[rowConfig.field];
            var checkedKeys = (rowState === null || rowState === void 0 ? void 0 : rowState.checkedKeys) || [];
            var labelId = "".concat(rowConfig.key, "-label");
            return (<div key={rowConfig.key} className="c-table-filter-modal__row c-table-filter-modal__multi-select-row">
        <div className="u-els-padding-bottom-1x c-table-filter-modal__multi-select-row-label">
          <span id={labelId} className="u-els-font-size-body-large">
            {rowConfig.label}
          </span>
          <span className="u-els-padding-left-1x u-els-font-size-meta u-els-color-n7">Select all that apply</span>
        </div>
        <div role="group" aria-labelledby={labelId} className="c-table-filter-modal__multi-select-row-checkbox">
          {rowConfig.options.map(function (option) { return (<ELSCheckBox key={option.key} name={option.key} value={option.name} checked={checkedKeys.includes(option.key)} changeHandler={function () {
                        _this.updateState(rowConfig, option.key);
                    }}>
              {option.name}
            </ELSCheckBox>); })}
        </div>
      </div>);
        };
        _this.renderSlideSwitchRow = function (rowConfig) {
            var rowState = _this.state.editingRowsState[rowConfig.field];
            return (<div key={rowConfig.key} className="c-table-filter-modal__row">
        <ELSSlideSwitch id={rowConfig.key} name={rowConfig.key} checked={(rowState === null || rowState === void 0 ? void 0 : rowState.isChecked) || false} changeHandler={function (evt) {
                    _this.updateState(rowConfig, evt.target.checked);
                }} labelStateIsOn={rowConfig.label} labelStateIsOff={rowConfig.label} size="small"/>
      </div>);
        };
        _this.renderDropdownRow = function (rowConfig) {
            var rowState = _this.state.editingRowsState[rowConfig.field];
            var labelId = "".concat(rowConfig.key, "-label");
            return (<div key={rowConfig.key} className={classnames('c-table-filter-modal__row c-table-filter-modal__dropdown-row', { 'c-table-filter-modal__dropdown-row-all-items': !rowState.selectedOptionValue })}>
        <div id={labelId} className="u-els-font-size-body-large c-table-filter-modal__range-row-label">
          {rowConfig.label}
        </div>
        <DropDown id={rowConfig.key} name={rowConfig.field} ariaLabel={rowConfig.label} changeHandler={function (evt) { return _this.updateState(rowConfig, evt.target.value); }} options={rowConfig.dropdownOptions} value={rowState.selectedOptionValue}/>
      </div>);
        };
        _this.renderCheckboxMenuRow = function (rowConfig) {
            var rowState = _this.state.editingRowsState[rowConfig.field];
            var checkedKeys = (rowState === null || rowState === void 0 ? void 0 : rowState.checkedKeys) || [];
            var labelId = "".concat(rowConfig.key, "-label");
            return (<div key={rowConfig.key} className={classnames('c-table-filter-modal__row c-table-filter-modal__checkbox-menu-row')}>
        <div id={labelId} className="u-els-font-size-body-large c-table-filter-modal__range-row-label">
          {rowConfig.label}
        </div>
        <CheckboxMenu inline allOptionDisplayTitle={rowConfig.placeHolder} customMultiSelectedLabel={MULTIPLE_SELECTED_DISPLAY} checkedKeys={checkedKeys} aria-labelledby={labelId} onOptionChange={function (keys) { return _this.updateState(rowConfig, keys); }} options={rowConfig.options}/>
      </div>);
        };
        _this.dateRangeChangeHandler = function (evt, selectedDay, rowConfig) {
            var dateValue = moment(selectedDay).format(TABLE_FILTER_DATE_FORMAT);
            var defaultValue = dateValue === 'Invalid date' ? 0 : dateValue;
            if (evt === TABLE_FILTER_DATE_EVENT.startDateChange) {
                _this.updateState(rowConfig, defaultValue, 'from');
            }
            else if (evt === TABLE_FILTER_DATE_EVENT.endDateChange) {
                _this.updateState(rowConfig, defaultValue, 'to');
            }
        };
        _this.renderDateRangeRow = function (rowConfig) {
            var rowState = _this.state.editingRowsState[rowConfig.field];
            var labelId = "".concat(rowConfig.key, "-date-label");
            var fromDate = (rowState === null || rowState === void 0 ? void 0 : rowState.from) ? moment(rowState.from, TABLE_FILTER_DATE_FORMAT).toDate() : null;
            var toDate = (rowState === null || rowState === void 0 ? void 0 : rowState.to) ? moment(rowState.to, TABLE_FILTER_DATE_FORMAT).toDate() : null;
            return (<div key={rowConfig.key} role="group" aria-labelledby={labelId} className="c-table-filter-modal__row c-table-filter-modal__date-range-row">
        <span id={labelId} className="u-els-font-size-body-large c-table-filter-modal__range-row-label">
          Date Taken
        </span>
        <Suspense fallback={<ELSInlineLoader />}>
          <div className="c-table-filter-modal__range-row-input-container">
            <span className="c-els-field c-table-filter-modal__range-row--date">
              <ELSDatePicker key={(rowState === null || rowState === void 0 ? void 0 : rowState.from) || 'date-range-from-blank'} id={"".concat(rowConfig.key, "-from")} label={"".concat(rowConfig.label, " from")} shouldHideLabel dateFormat={TABLE_FILTER_DATE_PICKER_FORMAT} startBlank={!fromDate} startDate={fromDate} validator={function (date) { return (toDate && date > toDate ? 'Date must be on or before the end date' : ''); }} handleDateChange={function (date) { return _this.dateRangeChangeHandler(TABLE_FILTER_DATE_EVENT.startDateChange, date, rowConfig); }}/>
            </span>
            <span aria-hidden="true" className="u-els-margin-1o2 c-table-filter-modal__range-row-to">
              to
            </span>
            <span className="c-els-field c-table-filter-modal__range-row--date">
              <ELSDatePicker key={(rowState === null || rowState === void 0 ? void 0 : rowState.to) || 'date-range-to-blank'} id={"".concat(rowConfig.key, "-to")} label={"".concat(rowConfig.label, " to")} shouldHideLabel dateFormat={TABLE_FILTER_DATE_PICKER_FORMAT} startBlank={!toDate} startDate={toDate} validator={function (date) { return (fromDate && date < fromDate ? 'Date must be on or after the start date' : ''); }} handleDateChange={function (date) { return _this.dateRangeChangeHandler(TABLE_FILTER_DATE_EVENT.endDateChange, date, rowConfig); }}/>
            </span>
          </div>
        </Suspense>
      </div>);
        };
        _this.renderRow = function (row) {
            switch (row.type) {
                case TableFilterRowType.RANGE:
                case TableFilterRowType.DECIMAL_RANGE: {
                    return _this.renderRangeRow(row);
                }
                case TableFilterRowType.MULTI_SELECT: {
                    return _this.renderMultiSelectRow(row);
                }
                case TableFilterRowType.SLIDE_SWITCH: {
                    return _this.renderSlideSwitchRow(row);
                }
                case TableFilterRowType.DATE_RANGE: {
                    return _this.renderDateRangeRow(row);
                }
                case TableFilterRowType.MONTH_RANGE: {
                    return _this.renderMonthYearRangeRow(row);
                }
                case TableFilterRowType.DROPDOWN: {
                    return _this.renderDropdownRow(row);
                }
                case TableFilterRowType.CHECKBOX_MENU: {
                    return _this.renderCheckboxMenuRow(row);
                }
                default: {
                    return null;
                }
            }
        };
        _this.renderDesktopModal = function () {
            return (<>
        {_this.props.description && (<div className="c-table-filter-modal__row c-table-filter-modal__description-row">
            <div className="c-table-filter-modal__description-row-content">{_this.props.description}</div>
          </div>)}
        {_this.props.rowsConfig.map(function (row) { return _this.renderRow(row); })}
      </>);
        };
        _this.renderMobileModal = function () {
            return (<Collapse activeKey={[]}>
        {_this.props.rowsConfig.map(function (row) {
                    return (<CollapsePanel key={row.key} labelKey={row.key} header={row.label}>
              {_this.renderRow(row)}
            </CollapsePanel>);
                })}
      </Collapse>);
        };
        _this.renderFooter = function () {
            return (<div className="u-els-margin-top-2x u-els-margin-top-none@mobile c-performance-report-modal__footer c-table-filter-modal__footer">
        <div className="u-els-display-none@mobile c-table-filter-modal__footer-cancel-container">
          <button type="button" onClick={_this.onCancelBtnClicked} onKeyDown={function (evt) { return _this.onButtonKeyDown(evt, _this.onCancelBtnClicked); }} className="c-table-filter-modal__footer-cancel">
            <ELSIcon name="close" color="secondary" size="1x" customClass="c-table-filter-modal__footer-cancel-icon" aria-hidden="true"/>
            <span className="u-els-padding-left-3o4">Cancel</span>
          </button>
        </div>
        <button type="button" className="c-table-filter-modal__footer-reset" onClick={_this.onResetFilterBtnClicked} onKeyDown={function (evt) { return _this.onButtonKeyDown(evt, _this.onResetFilterBtnClicked); }}>
          Reset Filters
        </button>
        <button type="button" className="c-els-button c-table-filter-modal__footer-apply" onClick={_this.onApplyFilterBtnClicked} onKeyDown={function (evt) { return _this.onButtonKeyDown(evt, _this.onApplyFilterBtnClicked); }}>
          Apply Filters
        </button>
      </div>);
        };
        _this.onButtonKeyDown = function (evt, callback) {
            var key = evt.key;
            if (key === PRESS_KEYS.ENTER || key === PRESS_KEYS.SPACE) {
                evt.preventDefault();
                callback();
                document.hasFocus();
            }
        };
        _this.onCancelBtnClicked = function () {
            _this.setState({
                modalVisible: false,
                editingRowsState: cloneDeep(_this.props.rowsState)
            });
        };
        _this.onResetFilterBtnClicked = function () {
            var _a, _b;
            (_b = (_a = _this.props).onFilterReset) === null || _b === void 0 ? void 0 : _b.call(_a);
            _this.setState({ editingRowsState: buildEmptyRowsState(_this.props.rowsConfig) });
        };
        _this.onResetAllFilterBtnClicked = function () {
            var _a, _b;
            var rowsConfig = _this.props.rowsConfig;
            var editingRowsState = buildEmptyRowsState(rowsConfig);
            _this.setState({ editingRowsState: editingRowsState });
            (_b = (_a = _this.props).onFilterReset) === null || _b === void 0 ? void 0 : _b.call(_a);
            _this.props.onFilter(cloneDeep(editingRowsState));
        };
        _this.onApplyFilterBtnClicked = function () {
            var _a, _b;
            _this.setState({ modalVisible: false });
            (_b = (_a = _this.props).onFilterApply) === null || _b === void 0 ? void 0 : _b.call(_a);
            _this.props.onFilter(cloneDeep(_this.state.editingRowsState));
        };
        _this.onTagClicked = function (config) {
            var _a;
            var key = config.key, type = config.type;
            var editingRowsState = __assign(__assign({}, cloneDeep(_this.props.rowsState)), (_a = {}, _a[key] = buildEmptyRowState(type), _a));
            _this.setState({ editingRowsState: editingRowsState });
            _this.props.onFilter(cloneDeep(editingRowsState));
        };
        _this.renderTags = function () {
            var _a = _this.props, rowsConfig = _a.rowsConfig, rowsState = _a.rowsState;
            var filterKeys = Object.keys(rowsState).filter(function (key) { return (rowsState[key].type === TableFilterRowType.SLIDE_SWITCH ? rowsState[key].isChecked : rowsState[key].hasData); });
            var classes = filterKeys.length ? 'u-els-margin-top-2x c-table-filter__tags u-els-margin-bottom-1o2' : 'u-els-margin-top c-table-filter__tags';
            if (filterKeys.length) {
                return (<div className={classes}>
          {filterKeys.map(function (key) {
                        var config = rowsConfig.find(function (row) { return row.key === key; });
                        return (<Suspense fallback={<ELSInlineLoader />} key={key}>
                <TableFilterTag config={config} filter={rowsState[key]} onTagClicked={_this.onTagClicked}/>
              </Suspense>);
                    })}

          <button type="button" className="c-els-button c-els-button--tertiary c-table-filter__reset-filter-btn" onClick={_this.onResetAllFilterBtnClicked} onKeyDown={function (evt) { return _this.onButtonKeyDown(evt, _this.onResetAllFilterBtnClicked); }}>
            <span className="u-els-font-size-base">Reset All Filters</span>
          </button>
        </div>);
            }
            return null;
        };
        _this.openModal = function () {
            var _a, _b;
            (_b = (_a = _this.props).onFilterButtonClicked) === null || _b === void 0 ? void 0 : _b.call(_a);
            _this.setState({
                editingRowsState: cloneDeep(_this.props.rowsState),
                modalVisible: true
            });
        };
        var rowsState = props.rowsState;
        _this.state = {
            editingRowsState: cloneDeep(rowsState),
            modalVisible: false,
            isPressEsc: false
        };
        return _this;
    }
    TableFilter.prototype.render = function () {
        var _this = this;
        var _a = this.props, searchKeyword = _a.searchKeyword, searchPlaceholder = _a.searchPlaceholder, filterHidden = _a.filterHidden, customClass = _a.customClass, children = _a.children, onSearch = _a.onSearch, searchHidden = _a.searchHidden, toggleFilterChecked = _a.toggleFilterChecked, onToggleFilter = _a.onToggleFilter, toggleFilterTitle = _a.toggleFilterTitle, rightContent = _a.rightContent;
        var _b = this.state, modalVisible = _b.modalVisible, isPressEsc = _b.isPressEsc;
        var filterShown = !filterHidden;
        return (<div className={classnames('c-table-filter', customClass)}>
        <div className="c-table-filter__filter-container">
          {children && <div className="u-els-padding-top-1o4 u-els-padding-right-1o2 c-table-filter__result">{children}</div>}
          {filterShown && (<button type="button" aria-expanded={modalVisible} aria-haspopup="dialog" className={classnames({ 'u-els-margin-right-3o4': !searchHidden, 'u-els-margin-left-auto': !!children }, 'c-els-button c-els-button--tertiary c-table-filter__filter-btn')} onKeyDown={function (evt) {
                    _this.onButtonKeyDown(evt, _this.openModal);
                }} onClick={this.openModal}>
              <ELSIcon name="filter" prefix="gizmo" size="1x" aria-hidden="true"/>
              <span className="u-els-margin-left-1o2 u-els-font-size-base">Filters</span>
            </button>)}

          {onToggleFilter && (<div className="o-els-flex-layout o-els-flex-layout--middle u-els-margin-right u-els-margin-left-1o4 c-table-filter__graded-only">
              <ELSSlideSwitch id="toggleGradedAssignments" name="toggleGradedAssignments" size="small" checked={toggleFilterChecked} changeHandler={function (evt) { return onToggleFilter(evt.target.checked); }} ariaLabel={toggleFilterTitle}/>
              <span aria-hidden="true" className="u-els-margin-left-1o2">
                {toggleFilterTitle}
              </span>
            </div>)}

          {!searchHidden && (<SearchBar placeholder={searchPlaceholder || 'Search'} value={searchKeyword} handleSearch={function (evt) {
                    onSearch(evt.target.value);
                }}/>)}
          {rightContent && <div className={classnames('o-els-flex-layout o-els-flex-layout--middle', { 'u-els-width-1o1': !children })}>{rightContent}</div>}
        </div>

        {filterShown && (<>
            {this.renderTags()}
            <Suspense fallback={<ELSInlineLoader />}>
              <PerformanceReportModal className="c-table-filter-modal" title={this.props.title || 'Filters'} label={this.props.label} visible={modalVisible} onCancel={this.onCancelBtnClicked} onOk={this.onApplyFilterBtnClicked} footer={this.renderFooter()} isDisabledEscEvt={isPressEsc} setIsDisabledEscEvtCallback={this.handleSetIsPressEsc}>
                <>
                  <div className="u-els-display-block u-els-display-none@mobile">{this.renderDesktopModal()}</div>
                  <div className="u-els-display-none u-els-display-block@mobile">{this.renderMobileModal()}</div>
                </>
              </PerformanceReportModal>
            </Suspense>
          </>)}
      </div>);
    };
    return TableFilter;
}(Component));
export default TableFilter;
